import React from 'react';
import { Box, Flex, Text } from '@ghq-abi/design-system';
// eslint-disable-next-line import/no-cycle
import { BaseModal } from '~/shared/components';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
}) => (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <Flex
        direction="column"
        align="center"
        justify="center"
        css={{
          padding: '$8',
          textAlign: 'center',
          minHeight: '300px',
        }}
      >
        <Box
          css={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#4CAF50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '$6',
          }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20,6 9,17 4,12" />
          </svg>
        </Box>

        <Text
          css={{
            fontSize: '$3xl',
            fontWeight: '$bold',
            color: '$gray900',
            marginBottom: '$4',
            textAlign: 'center',
            lineHeight: '$tight',
          }}
        >
          Submission Confirmed
        </Text>
      </Flex>
    </BaseModal>
  );
